import React, { useEffect, useState } from "react";
import axios from "axios";
import { HERO_SPRITES } from "./images";

const API = process.env.REACT_APP_API_URL;

const DIFFICULTIES = [
  { key: "facile", label: "Facile" },
  { key: "moyen", label: "Moyen" },
  { key: "difficile", label: "Difficile" },
  { key: "epique", label: "Épique" },
];

const MODES = [
  { key: "normal", label: "Classique" },
  { key: "aventure", label: "Aventure" },
];

const LeaderboardScreen = ({ onBack }) => {
  const [difficulty, setDifficulty] = useState("facile");
  const [mode, setMode] = useState("normal");
  const [scope, setScope] = useState("global"); // "global" | "mine"
  const [leaderboard, setLeaderboard] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLeaderboard(null);
    setError(null);

    axios
      .post(`${API}/api/dungeon/leaderboard`, { difficulty, scope, mode })
      .then((res) => setLeaderboard(res.data.leaderboard))
      .catch((err) => {
        console.error(err);
        setError("Impossible de charger le classement.");
      });
  }, [difficulty, scope, mode]);

  return (
    <div className="leaderboard-screen">
      <h2>🏆 Classement</h2>
      <button onClick={onBack}>← Retour</button>

      <div className="leaderboard-scope-toggle">
        <button
          onClick={() => setScope("global")}
          className={scope === "global" ? "active-tab" : ""}
          disabled={scope === "global"}
        >
          Classement général (top 10)
        </button>
        <button
          onClick={() => setScope("mine")}
          className={scope === "mine" ? "active-tab" : ""}
          disabled={scope === "mine"}
        >
          Mon classement
        </button>
      </div>

      <div className="leaderboard-tabs">
        {MODES.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setMode(key)}
            className={mode === key ? "active-tab" : ""}
            disabled={mode === key}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="leaderboard-tabs">
        {DIFFICULTIES.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setDifficulty(key)}
            className={difficulty === key ? "active-tab" : ""}
            disabled={difficulty === key}
          >
            {label}
          </button>
        ))}
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {!leaderboard && !error && <p>Chargement...</p>}

      {leaderboard && (
        <>
          <div className="leaderboard-table-wrapper">
            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Joueur</th>
                  <th>Score</th>
                  <th>Étage atteint</th>
                  <th>Cause</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.map((entry, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td className="leaderboard-player-cell">
                      <img
                        src={HERO_SPRITES[entry.spriteId] || HERO_SPRITES[1]}
                        alt=""
                        className="leaderboard-sprite"
                      />
                      {entry.username}
                    </td>
                    <td>{entry.score}</td>
                    <td>{entry.floor}</td>
                    <td className="leaderboard-cause">
                      {entry.status === "victory"
                        ? "🏆"
                        : entry.status === "abandoned"
                          ? "🏳️"
                          : "💀"}{" "}
                      {entry.cause}
                    </td>
                  </tr>
                ))}
                {leaderboard.length === 0 && (
                  <tr>
                    <td colSpan={5}>
                      Aucun score enregistré pour cette difficulté.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Version mobile : cartes empilées, aucun scroll horizontal nécessaire */}
          <ul className="leaderboard-cards">
            {leaderboard.map((entry, i) => (
              <li key={i} className="leaderboard-card">
                <div className="leaderboard-card-top">
                  <span className="leaderboard-card-rank">#{i + 1}</span>
                  <img
                    src={HERO_SPRITES[entry.spriteId] || HERO_SPRITES[1]}
                    alt=""
                    className="leaderboard-sprite"
                  />
                  <span className="leaderboard-card-username">
                    {entry.username}
                  </span>
                  <span className="leaderboard-card-score">
                    {entry.score} pts
                  </span>
                </div>
                <div className="leaderboard-card-bottom">
                  <span>Étage {entry.floor}</span>
                  <span>
                    {entry.status === "victory"
                      ? "🏆"
                      : entry.status === "abandoned"
                        ? "🏳️"
                        : "💀"}{" "}
                    {entry.cause}
                  </span>
                </div>
              </li>
            ))}
            {leaderboard.length === 0 && (
              <li className="leaderboard-card">
                Aucun score enregistré pour cette difficulté.
              </li>
            )}
          </ul>
        </>
      )}
    </div>
  );
};

export default LeaderboardScreen;
